import { render, staticRenderFns } from "./Mypacks.vue?vue&type=template&id=161344a8&"
import script from "./Mypacks.vue?vue&type=script&lang=js&"
export * from "./Mypacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports